const intialStore = {
    fallbackEntity: {},
    editorState: '',
};

export default intialStore;
